import { ADMIN_BIZ_UPDATE } from "../actions/types"
const INITIAL_STATE = { loading: false, errors: {}, _doc: {}, updatedDoc: {} }
export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case ADMIN_BIZ_UPDATE:
      return { ...state, updatedDoc: { ...state.updatedDoc, [action.payload.field]: action.payload.value } }
    default:
      return state
  }
}